/**
 * Order numbers live in a different column per order client, and internal orders have no
 * external number at all. `OrderModel` resolves this server-side and exposes the result as
 * `order_number_with_client` / `order_route_id` / `order_route_client`.
 *
 * The functions below are the single client-side fallback for payloads that still ship only
 * the raw columns. Prefer exposing the resolved fields from the backend over widening it.
 *
 * Import the named functions in `<script setup>` components, or the default mixin in
 * components using the options API.
 */
const CLIENTS_NUMBERED_BY_ORDER_NO = ['PSA', 'OneWebshop', 'Webglobe']
const CLIENTS_NUMBERED_BY_ORDER_ID = ['OSA', 'WooCommerce']

export const INTERNAL_ORDER_CLIENT = 'internal'

/**
 * @param {Object} order Raw `client`/`order_no`/`order_id`/`id` columns.
 * @returns {String|Number} The identifier the order details page is reachable by.
 */
export function orderRouteId (order) {
    if (CLIENTS_NUMBERED_BY_ORDER_NO.includes(order.client)) {
        return order.order_no
    }

    if (CLIENTS_NUMBERED_BY_ORDER_ID.includes(order.client)) {
        return order.order_id
    }

    return order.id
}

/**
 * Params for the `orders.details` route.
 *
 * @param {Object} order Either the resolved fields, or raw `client`/`order_no`/`order_id`/`id` columns.
 * @returns {{order: (String|Number), client: String}}
 */
export function orderDetailsRouteParams (order) {
    return {
        order: order.order_route_id ?? orderRouteId(order),
        client: order.order_route_client ?? order.client ?? INTERNAL_ORDER_CLIENT
    }
}

export default {
    methods: {
        orderDetailsRouteParams,
        orderRouteId
    }
}
